import { css } from '@emotion/core';
import { mq } from '../../cssInJs';
export default {
  button: css(mq({
    position: 'absolute',
    left: '1rem',
    top: ['48px', '56px'],
    lineHeight: '1.6rem',
    color: '#0056b3',
    fontSize: ['12px', null, '15px'],
    zIndex: '1001',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '32px',
    minHeight: '32px',
    transition: 'all 0.3s ease',
    '&:hover': {
      color: '#0056b3',
      textDecoration: 'none'
    }
  })),
}